import { useEffect, useState, useRef } from 'react';

import { FixedNumber } from '../utility';
import './Modal.css';

const MIN_VALUE = 0.1;
const MAX_VALUE = 10000;

function Modal({ label, defaultValue, onSave, onClose, refNode }) {
	const modalRef = useRef();
	const [value, setValue] = useState(defaultValue);

	function onSubmit(e) {
		e.preventDefault();
		value !== '' && onSave(value > MAX_VALUE ? MAX_VALUE : (value < MIN_VALUE ? MIN_VALUE : value));
		onClose();
	}

	function onChange(e) {
		if (e.target.value !== '')
			setValue(FixedNumber(e.target.value));
		else
			setValue('');
	}

	useEffect(() => {
		if (modalRef.current) {
			const bodyRect = document.body.getBoundingClientRect();
			const rect = refNode.getBoundingClientRect();
			const svgRect = refNode.viewportElement.getBoundingClientRect();
			const top = (rect.y < svgRect.y ? svgRect.y + 20 : rect.top - bodyRect.top + rect.height) + 10;
			const left = rect.left + rect.width / 2 - modalRef.current.clientWidth / 2;
			modalRef.current.style = `top: ${top}px; left: ${left}px`;
			modalRef.current.querySelector('input').select();
		}
	}, [refNode]);

	
	useEffect(() => {
		function onClick(e) {
			e.stopPropagation();
			if (!modalRef.current.contains(e.target)) onClose();
		}
		function onEsc(e) {
			if (e.key === 'Escape') onClose();
		}
		setTimeout(() => {
			document.addEventListener('click', onClick);
			document.addEventListener('keydown', onEsc);
		}, 1);
		return () => document.removeEventListener('click', onClick);
	}, [refNode]);

	useEffect(() => {
		setValue(defaultValue);
	}, [defaultValue]);

	return (
		<div ref={modalRef} className="input-modal">
			<form onSubmit={onSubmit}>
				<div>
					{label}
					<input
						className="inner-panel-boxed-input"
						type="number"
						value={value}
						onChange={onChange}
						min={MIN_VALUE}
						max={MAX_VALUE}
						step="0.1"
					/> m
				</div>
				<button type="submit">Apply</button>
			</form>
		</div>
	);
}

export default Modal;